module.exports = __webpack_public_path__ + "static/media/wsd-logo.d2845b3a.png";